import { type FormEvent, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router'

import { parseDateRange } from '@fv/client-core'
import { fvDate } from '@fv/dates'
import type { CustomDateRange } from '@fv/models'

import { AdminDateInput } from '@/components/shared/AdminDateInput'

type Props = {
  value: string
  onChange: (value: CustomDateRange) => void
}
export const CustomTimeframe = ({ value, onChange }: Props) => {
  const { isCustom: isCustomRange, start, end } = parseDateRange(value)

  if (!isCustomRange || !start || !end) return null

  return (
    <>
      <AdminDateInput
        className="mr-2"
        name="start"
        required
        value={start}
        onChange={val => {
          onChange(`${+val}-${+end}`)
        }}
      />

      <AdminDateInput
        className="mr-2"
        name="end"
        required
        value={end}
        onChange={val => {
          onChange(`${+start}-${+val}`)
        }}
      />
    </>
  )
}

export const QueryStringCustomTimeframe = () => {
  const [error, setError] = useState('')
  const [params, setParams] = useSearchParams()
  const range = params.get('range') ?? ''
  const [value, setValue] = useState(range)

  useEffect(() => {
    setValue(range)
  }, [range])

  const { isCustom, start, end } = parseDateRange(value)
  if (!isCustom || !start || !end) return null
  return (
    <form
      className="mb-1 mt-4"
      onSubmit={(e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        e.stopPropagation()

        if (!start || !end) {
          return setError('both dates are required')
        }

        if (fvDate(start).isAfter(fvDate(end))) {
          return setError('Start date must come before end date.')
        }

        setParams(p => {
          p.set('range', `${fvDate(start).valueOf()}-${fvDate(end).valueOf()}`)
          return p
        })
      }}
    >
      <div className="flex items-center w-80">
        <CustomTimeframe value={value} onChange={v => setValue(v)} />

        <button className="mr-2" type="submit">
          Go
        </button>
      </div>
      {error && <span className="text-danger">{error}</span>}
    </form>
  )
}
